import { ReviewState } from './types';

export const getReviewState = (state: any): ReviewState => state.review;
